import React, { Component } from 'react';
import {
  Card, CardBody, Col, Table, Badge, Button, UncontrolledTooltip,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import Moment from 'moment';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';

import CommonService from '../../../../services/CommonService';
import CommissaryService from '../../../../services/CommissaryService';
import DistributionModals from './DistributionModals';
import global from '../../../../global';

class Commissarydistribution extends Component {
  static propTypes = {
    itemID: PropTypes.string.isRequired,
  };

  constructor(props) {
      super(props);
      this.userData = JSON.parse(localStorage.getItem('userData'));
      const { itemID } = this.props;
      this.currDate = new Date();
      this.state = {
        modal: false,
        withdrawalList: [],
        inventoryInfo: {
          id: '0',
          name: 'Product Name',
          total_beginning: '0',
          total_receive: '0',
          total_receive_pending: '0',
          total_out: '0',
          return: '0',
          new_balance: '0',
        },
        formdata: {
        },
        locationID: 0,
        goTo: false,
        goToPage: '/',
      };
      this.inventory_control_id = itemID;
      this.toggleModal = this.toggleModal.bind(this);
      this.hasItemID = true;
  }

  componentDidMount() {
    const { itemID } = this.props;
    this.isLoading = true;
    if (itemID == null) {
      this.hasItemID = false;
    } else {
      this.hasItemID = true;
      this.onLoadInventory();
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'deliver') {
      if (e) {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: e.value, deliverTxt: e.label },
        }));
      } else {
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, deliverVal: undefined, deliverTxt: undefined },
        }));
      }
    } else if (fieldName === 'transaction') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, transactionType: e },
      }));
    } else if (fieldName === 'number') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
      }));
    } else if (fieldName === 'date') {
      const date = new Date(e);
      const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, deliveryDate: date, deliveryDate_txt: dateText },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  onLoadInventory = async () => {
    try {
      const response = await CommissaryService.getDistributionData(this.inventory_control_id);
      if (response !== false) {
        if (this.isLoading) {
          this.setState({
            withdrawalList: response.inventory_control_entry,
            locationID: response.location_id,
            inventoryInfo: {
              name: response.product_name,
              total_beginning: response.stock_beginning,
              total_receive: response.stock_receive,
              total_receive_pending: response.stock_receive_pending,
              total_out: response.stock_out,
              return: response.stock_return,
              new_balance: response.stock_balance,
            },
          });

          this.setState(prevState => ({
            formdata: { ...prevState.formdata, unitCost: response.unit_cost },
          }));
        }
      } else {
        this.setState({ goTo: true, goToPage: '/inventory/logistic/list' });
      }
    } catch (err) {
      console.log('Error: ', err.message);
      this.isLoading = false;
    }
  }

  confirmStock(e, invID, sts, quantity = 0) {
    e.preventDefault();
    this.toggleModal();
    this.setState({
      formdata: {
        inventoryId: invID,
        actualQuantity: quantity,
        note: '',
        status: sts,
      },
    });
    // submit form
    this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
  }

  withdrawStock(e) {
    e.preventDefault();
    this.toggleModal();
    const { locationID } = this.state;

    this.setState({
      formdata: {
        perKilo: '',
        transactionType: '3',
        location_id: locationID,
        deliveryDate: this.currDate,
        deliveryDate_txt: Moment(this.currDate).format('YYYY-MM-DD HH:mm:ss'),
        added_by: this.userData.user_id,
      },
    });
    // submit form
    this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
  }

  async submitConfirmation(e) {
    e.preventDefault();
    const {
      withdrawalList, formdata, inventoryInfo, locationID,
    } = this.state;

    formdata.locationId = locationID;
      if ((formdata.status === 1 && formdata.actualQuantity) || (formdata.status === 2 && formdata.note)) {
        this.setState({ errorMsg: '' });
        const result = await CommonService.updateData('updatestockstatus', formdata);
        if (result === true) {
          // update list info
          withdrawalList.filter((listResp) => {
            if (listResp.inventory_control_entry_id === formdata.inventoryId) {
              listResp.actual_quantity = formdata.actualQuantity;
              listResp.status = formdata.status;
              listResp.note = formdata.note;
            }
            return listResp;
          });
          // update inventoryInfo data
          let tempQuantity = parseFloat(formdata.actualQuantity, 10);
          if (parseInt(formdata.status, 10) === 2) {
            tempQuantity = parseFloat(formdata.quantity, 10);
          }
          inventoryInfo.total_receive_pending = parseFloat(inventoryInfo.total_receive_pending, 10) > 0 ? parseFloat(inventoryInfo.total_receive_pending, 10) - tempQuantity : 0;
          if (parseInt(formdata.status, 10) === 1) {
            inventoryInfo.total_receive = parseFloat(inventoryInfo.total_receive, 10) + tempQuantity;
            inventoryInfo.new_balance = parseFloat(inventoryInfo.new_balance, 10) + tempQuantity;
          } else if (parseInt(formdata.status, 10) === 2) {
            inventoryInfo.new_balance = parseFloat(inventoryInfo.new_balance, 10) > 0 ? parseFloat(inventoryInfo.new_balance, 10) - tempQuantity : 0;
          }
          // update state
          this.setState({ withdrawalList, modal: false });
          swal('', 'Successfully updated information!', 'success');
        } else {
          this.setState({ modal: false });
          swal('', 'Failed to update information!', 'danger');
        }
      } else {
        this.setState({ errorMsg: 'Required fields are empty.' });
      }
 }

  toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      withdrawalList, modal, formdata, errorMsg, goTo, goToPage, inventoryInfo, locationID,
    } = this.state;
    const { movementStatus, iceType } = global;

    if (this.hasItemID === false) {
      return (<Redirect to="/login" />);
    }

    if (goTo === true) {
      return (<Redirect to={goToPage} />);
    }

    return (
        <Col md={12}>
          <DistributionModals
            modal={modal}
            toggle={this.toggleModal}
            handleChange={this.handleChange}
            postValue={formdata}
            errorMsg={errorMsg}
            handleSubmit={this.handleSubmit}
          />
        <Card className="panel panel--primary" id="users_table">
            <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">{inventoryInfo.name}</h5>

              <div className="panel__btns">
                  <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to={`/inventory/logistic/dashboard/${locationID}`}>
                  <i className="fa fa-arrow-left" />
                  <span>Back</span>
                  </Link>
              </div>
            </div>
            <div className="panel__content">
                <div className="stock-box__container stock-6 stock-sm">
                  <div className="stock-box outline stock-aqua">
                    <div className="stock-box__icon"><i className="fa fa-box" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.total_beginning !== '0' !== '0' ? `${inventoryInfo.total_beginning} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">Beginning</h4>
                  </div>
                  <div className="stock-box outline stock-blue">
                    <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.total_receive !== '0' ? `${inventoryInfo.total_receive} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">Total Received</h4>
                  </div>
                  <div className="stock-box outline stock-orange">
                    <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.total_receive_pending !== '0' ? `${inventoryInfo.total_receive_pending} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">Total Transfer Pending</h4>
                  </div>
                  <div className="stock-box outline stock-red">
                    <div className="stock-box__icon"><i className="fa fa-dolly" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.total_out !== '0' ? `${inventoryInfo.total_out} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">Total Out</h4>
                  </div>
                  <div className="stock-box outline stock-pink">
                    <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.return !== '0' ? `${inventoryInfo.return} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">Return</h4>
                  </div>
                  <div className="stock-box outline stock-green">
                    <div className="stock-box__icon"><i className="fa fa-boxes" /></div>
                    <h3 className="stock-box__num">{inventoryInfo && inventoryInfo.new_balance ? `${inventoryInfo.new_balance} kgs.` : 0 }</h3>
                    <h4 className="stock-box__text">New Balance</h4>
                  </div>
                </div>
            </div>
            <div className="panel__content">
                <Table responsive striped>
                <thead className="th-vtop">
                    <tr>
                      <th>Location</th>
                      <th>Batch Code</th>
                      <th>RR #</th>
                      <th className="text-center">Type</th>
                      <th className="text-center">Quantity</th>
                      <th className="text-center">Quantity <span className="block lh-13">(<span className="fs-12 text-blue"> Actual </span>)</span></th>
                      <th className="text-center">Quantity <span className="block lh-13">(<span className="fs-12 text-orange"> Remaining </span>)</span></th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Note</th>
                      <th className="text-center">Date</th>
                      <th width="90px" className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                  {
                    withdrawalList !== false && withdrawalList.map((item, i) => {
                      item.status = parseInt(item.status, 10);
                      item.type = parseInt(item.type, 10);

                      let statusColor = 'success';
                      const inventoryID = item.inventory_control_entry_id;

                      if (item.status === 0) {
                        statusColor = 'warning';
                      } else if (item.status === 2) {
                        statusColor = 'danger';
                      }

                      return (
                        <tr key={inventoryID} className="text-center">
                          <td className="text-left">{item.type === 3 ? '- -' : item.location_name}</td>
                          <td className="text-left">{item.batch_code ? item.batch_code : '- -'}</td>
                          <td className="text-left">{item.delivery_number ? item.delivery_number : '- -'}</td>
                          <td>{item.receive_type === 0 ? <b className="text-green">{iceType[4]}</b> : item.receive_type === 2 ? <b className="text-red">{iceType[5]}</b> : iceType[item.type]}</td>
                          <td>{item.quantity && item.quantity !== '0' ? `${item.quantity} kgs.` : <b className="text-red">0</b>}</td>
                          <td>{item.actual_quantity && item.actual_quantity !== '0' ? `${item.actual_quantity} kgs.` : <b className="text-red">0</b>}</td>
                          <td>{item.type === 2 || item.status === 0 ? '--' : item.remaining_quantity && item.remaining_quantity !== '0' ? `${item.remaining_quantity} kgs.` : <b className="text-red">0</b>}</td>
                          <td><Badge color={statusColor}>{movementStatus[(item.name_from && item.status !== 1 ? item.status : 4)]}</Badge></td>
                          <td className="white-space-pre-wrap">{item.note ? item.note : '- -'}</td>
                          <td>{item.date_added}</td>
                          <td>
                            {
                              item.status === 0 && item.type === 1 ? (
                                <span>
                                  {/* Approve button */}
                                  <Button color="success" className="btn-xs" title="Approve" onClick={e => this.confirmStock(e, inventoryID, 1, item.quantity)} id={`approvebtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`approvebtn${i + 1}`}>Approve</UncontrolledTooltip>
                                  {/* Deny button */}
                                  <Button color="danger" className="btn-xs" title="Deny" onClick={e => this.confirmStock(e, inventoryID, 2, item.quantity)} id={`denybtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`denybtn${i + 1}`}>Deny</UncontrolledTooltip>
                                </span>
                              ) : '--'
                            }
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
                </Table>
            </div>
            </CardBody>
        </Card>
        </Col>
    );
  }
}

export default withTranslation('common')(Commissarydistribution);
